import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { FullPageLoader } from '@/components/FullPageLoader';
import { AppShell } from '@/components/layouts/AppShell';
import { useTranslation } from '@/hooks/useTranslation';
import { OnboardingModal, useAuthStore } from '@/modules/auth';
import { djangoLoginUrl } from '@/modules/auth/services/loginRedirect';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loading } = useAuthStore();
  const { t } = useTranslation();
  const location = useLocation();
  const isProd = import.meta.env.PROD;

  if (loading) {
    return <FullPageLoader />;
  }

  if (!isAuthenticated) {
    // In production, redirect to Django login
    if (isProd) {
      const currentPath = window.location.pathname + window.location.search;
      window.location.href = djangoLoginUrl(currentPath);
      return (
        <div className="flex min-h-screen items-center justify-center">
          <div className="text-lg">{t('Redirecting to login...')}</div>
        </div>
      );
    }

    // In development, redirect to login page
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <AppShell>
      {children}
      <OnboardingModal />
    </AppShell>
  );
}
